import useAppDispatch from '../../hooks/useAppDispatch';
import useAppSelector from '../../hooks/useAppSelector';
import { useState } from 'preact/hooks';
import { useTranslation } from '../../hooks/useTranslation';
import { CategoryBoundingBox } from '../../models/Product';
import { getBiggestBoundingBox } from '../../services/features/main/ProductSearchByImageMainFeatureHandler';
import ChatClickableButton from './ChatClickableButton';
import Chip from '../chip/Chip';
import AssistantChatMessageButton from './AssistantChatMessageButton';
import ProductImage from '../product/product-image/ProductImage';
import './AssistantChatProductSearchByImageMessage.less';

const AssistantChatProductSearchByImageMessage = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const mainFeatureItem = useAppSelector(
        state => state.featureState.mainFeatureItem
    );

    if (mainFeatureItem?.featureType === 'product-search-by-image') {
        return (
            <>
                <AssistantChatMessageButton
                    content={{
                        contentType: 'button',
                        featureType: 'product-search-combinations-by-image',
                        contextualProductIds: []
                    }}
                />
                <AssistantChatMessageButton
                    content={{
                        contentType: 'button',
                        featureType: 'product-search-similar-by-image',
                        contextualProductIds: []
                    }}
                />
            </>
        );
    }

    if (
        mainFeatureItem?.featureType === 'product-search-similar-by-image' ||
        mainFeatureItem?.featureType === 'product-search-combinations-by-image'
    ) {
        const [selectedBoundingBox, setSelectedBoundingBox] = useState<
            CategoryBoundingBox | undefined
        >(getBiggestBoundingBox(mainFeatureItem.boundingBoxes));

        if (
            selectedBoundingBox &&
            !mainFeatureItem.boundingBoxes.includes(selectedBoundingBox)
        ) {
            setSelectedBoundingBox(
                getBiggestBoundingBox(mainFeatureItem.boundingBoxes)
            );
        }

        const boundingBoxCategory =
            selectedBoundingBox?.categoryTranslatedValue ??
            selectedBoundingBox?.categoryValue;
        return (
            <>
                <div className="bri-AssistantChatBoundingBoxSelector">
                    <ProductImage
                        image={{
                            url:
                                mainFeatureItem.imageDataUrl ||
                                mainFeatureItem.imageUrl,
                            categoryBoundingBoxes:
                                mainFeatureItem.boundingBoxes,
                            width: mainFeatureItem.imageWidth,
                            height: mainFeatureItem.imageHeight
                        }}
                        isVisible={true}
                        defaultWidth={100}
                        showBoundingBoxes
                        selectedBoundingBox={selectedBoundingBox}
                        onChangeSelectedBoundingBox={setSelectedBoundingBox}
                    />
                </div>

                <ChatClickableButton
                    startIconId={'join'}
                    onClick={() => {
                        dispatch.featureState.removeProductSearchByImageMessage();
                        return dispatch.featureState.startFeature({
                            featureType: 'product-search-combinations-by-image',
                            imageId: mainFeatureItem.imageId,
                            imageUrl: mainFeatureItem.imageUrl,
                            imageDataUrl: mainFeatureItem.imageDataUrl,
                            imageWidth: mainFeatureItem.imageWidth,
                            imageHeight: mainFeatureItem.imageHeight,
                            boundingBoxes: mainFeatureItem.boundingBoxes,
                            selectedBoundingBox
                        });
                    }}
                >
                    {boundingBoxCategory ? (
                        <>
                            {t(
                                'PRODUCT_SEARCH_CHAT_FEATURE_COMBINATIONS_BY_CATEGORY'
                            )}{' '}
                            <Chip variant="secondary-gray-200">
                                {boundingBoxCategory}
                            </Chip>
                        </>
                    ) : (
                        t(
                            'PRODUCT_SEARCH_CHAT_FEATURE_COMBINATIONS_BY_FULL_IMAGE'
                        )
                    )}
                </ChatClickableButton>
                <ChatClickableButton
                    startIconId={'similar'}
                    onClick={() => {
                        dispatch.featureState.removeProductSearchByImageMessage();
                        return dispatch.featureState.startFeature({
                            featureType: 'product-search-similar-by-image',
                            imageId: mainFeatureItem.imageId,
                            imageUrl: mainFeatureItem.imageUrl,
                            imageDataUrl: mainFeatureItem.imageDataUrl,
                            imageWidth: mainFeatureItem.imageWidth,
                            imageHeight: mainFeatureItem.imageHeight,
                            boundingBoxes: mainFeatureItem.boundingBoxes,
                            selectedBoundingBox
                        });
                    }}
                >
                    {boundingBoxCategory ? (
                        <>
                            {t(
                                'PRODUCT_SEARCH_CHAT_FEATURE_SIMILAR_TO_CATEGORY'
                            )}{' '}
                            <Chip variant="secondary-gray-200">
                                {boundingBoxCategory}
                            </Chip>
                        </>
                    ) : (
                        t('PRODUCT_SEARCH_CHAT_FEATURE_SIMILAR_TO_FULL_IMAGE')
                    )}
                </ChatClickableButton>
            </>
        );
    }
};

export default AssistantChatProductSearchByImageMessage;
